import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3535e92c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "data-kt-image-input": "true",
  class: "mb-8 image-input image-input-empty image-input-outline mb-3"
}
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1))
const _hoisted_5 = ["name"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "image-generate-spinner"
}
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_ctx.input)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass({ required: _ctx.input.required })
          }, _toDisplayString(_ctx.input.label), 3)
        ]),
        _createElementVNode("div", {
          class: "image-input-wrapper w-150px h-150px",
          style: _normalizeStyle(_ctx.bgStyle)
        }, null, 4),
        _createElementVNode("label", {
          class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow edit-image",
          "data-kt-image-input-action": "change",
          "data-bs-toggle": "tooltip",
          title: `Change ${_ctx.input.label}`
        }, [
          _hoisted_4,
          _createVNode(_component_Field, {
            type: "file",
            name: _ctx.input.name,
            id: _ctx.input.name,
            accept: ".png, .jpg, .jpeg",
            onChange: _ctx.onChange
          }, null, 8, ["name", "id", "onChange"]),
          _createElementVNode("input", {
            type: "hidden",
            name: `${_ctx.input.name}_remove`
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_3),
        (_ctx.values[_ctx.input.valueAttr] !== '')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.input.clearImage && _ctx.input.clearImage(_ctx.values))),
              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow remove-image",
              "data-kt-image-input-action": "removeImage",
              "data-bs-toggle": "tooltip",
              title: "Cancel"
            }, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.showGenerate)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "image-generate-btn",
              disabled: _ctx.generating,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.generateImage && _ctx.generateImage(...args)))
            }, [
              (_ctx.generating)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "✨")),
              _createTextVNode(" " + _toDisplayString(_ctx.generating ? 'Generating...' : _ctx.input.generateAction.label), 1)
            ], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}